
<script setup>
import { EmptyPage, Label, Input, Button } from '@components'
import { ref } from 'vue'

const emptyPageContent = {
    heading: {
        title: "Invite staffs",
        subtitle: "To invite staffs write their email addresses and click on invite.",
        imgLink: 'shape_20.png'
    }
}

const user_email = ref('')

const submitInvite = () => {
    console.log(user_email.value)
}
</script>

<template>
    <div class="md:max-w-[563px] m-auto">
        <EmptyPage :pageContent="emptyPageContent" />

        <form @submit.prevent="submitInvite">
            <Label>Users</Label>
            <Input v-model="user_email" class="mt-1.5" />

            <Button submit type="primary" size="lg" radius="square" class="w-full mt-5">Invite</Button>
        </form>
    </div>
</template>

<style>

</style>